// extracted by mini-css-extract-plugin
module.exports = {"suggestedDishList":"h-ikQRNDqxbuxGeWt_V8S","externalId":"JBoDGs8ftV7z9jgGtpvWw"};